<div class="mr-2">
  <button (click)="importObject.emit(object)"
          class="btn btn-outline-primary btn-sm float-left"
          title="{{importConfig?.buttonLabel | translate}}">
    <span aria-hidden="true" class="fas fa-cloud-download-alt fa-fw"></span>
  </button>
</div>
